import React, { ReactNode } from 'react';

import { locale } from '@trqk/utils';

interface ChartOrEmptyChartMessageProps {
    data: unknown[];
    children: ReactNode;
    height: number;
}

export const ChartOrEmptyMessage = ({
    data,
    children,
    height,
}: ChartOrEmptyChartMessageProps): JSX.Element => {
    if (data.length < 1) {
        return (
            <div
                className="flex items-center justify-center text-tertiary-400 italic h-full text-sm font-normal"
                style={{ height }}
            >
                {locale.enUS.CHART_HAS_NO_DATA}
            </div>
        );
    }

    return <>{children}</>;
};
